import type { App } from "vue";
import type { Router } from "vue-router";
import Acl from "@/acl";
import { useAuthStore } from "@/stores/auth";

export default function setupAcl(app: App, router: Router): void {
  // Initialize with current user from Pinia store
  const authStore = useAuthStore();

  // Get user and tenant from Pinia
  const userAccessor = () => authStore.currentUser;
  const tenantAccessor = () => authStore.currentTenant;

  const tokenAccessor = () => authStore.token;
  app.use(Acl, { router, userAccessor, tenantAccessor, tokenAccessor });
}
